export default __webpack_public_path__ + "static/media/logo-wobg.35bdbe03.png";